export const OfferDishesCardLxViewbid = 'b_sailor_c_qgcy1392_mv';
export const OfferDishesCardLxClickbid = 'b_sailor_c_qgcy1392_mc';

// 品牌
export const OfferLandingDishesCardComponentId = 'mach_pro_sailor_c_offer_landing_dishes_golden_card';
